import { render, staticRenderFns } from "./Monetization.vue?vue&type=template&id=4a49c957&"
import script from "./Monetization.vue?vue&type=script&lang=js&"
export * from "./Monetization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports